import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    window.addEventListener(
      "click",
      (this._outsideClickHandler = this.close.bind(this)),
    );
  }

  disconnect() {
    window.removeEventListener("click", this._outsideClickHandler);
    this.unlockScroll();
  }

  show(e) {
    e.stopPropagation();
    this.menuTarget.classList.remove("!hidden");
    this.lockScroll();
  }

  stop(e) {
    e.stopPropagation();
  }

  close(event) {
    if (this.menuTarget.classList.contains("!hidden")) return;

    this.menuTarget.classList.add("!hidden");
    this.unlockScroll();
  }

  lockScroll() {
    if (!this.shouldLockScroll) return;

    document.body.classList.add("overflow-hidden");
  }

  unlockScroll() {
    if (!this.shouldLockScroll) return;

    document.body.classList.remove("overflow-hidden");
  }

  get shouldLockScroll() {
    return this.menuTarget.dataset.toggleLockScroll === "true";
  }
}
